import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/state.types';
import { CategoryEnum } from '../../search.types';

function hasAggregation(
  aggregations: StateType['aggregations'],
  key: CategoryEnum,
): boolean {
  return aggregations[key] && aggregations[key].length > 0;
}

const mapState = ({ aggregations, queryParams }: StateType) => ({
  shouldDisplayVille: hasAggregation(aggregations, 'ville'),
  shouldDisplayDomaine: hasAggregation(aggregations, 'domaine'),
  shouldDisplayPubli: hasAggregation(aggregations, 'publi'),
  shouldDisplaySolution: hasAggregation(aggregations, 'solution'),
  shouldDisplayPublisher: hasAggregation(aggregations, 'publisher'),
  shouldDisplayCommentaryAccess: hasAggregation(
    aggregations,
    'commentaryAccess',
  ),
  shouldDisplayJuridiction: hasAggregation(aggregations, 'juridiction'),
  shouldDisplayDate:
    (aggregations.dates && aggregations.dates.length) ||
    queryParams.type === 'arret' ||
    queryParams.type === 'commentary',
  shouldDisplayExclude: queryParams.type === 'arret',
  shouldDisplayParties: queryParams.type === 'arret',
  shouldDisplayInForceDate: queryParams.type === 'law',
  shouldDisplayTextCode:
    queryParams.type === 'law' && hasAggregation(aggregations, 'textCode'),
  shouldDisplayCollectiveAgreements:
    queryParams.type === 'law' &&
    hasAggregation(aggregations, 'collectiveAgreements'),
  shouldDisplayOtherLegislation:
    queryParams.type === 'law' &&
    hasAggregation(aggregations, 'otherLegislation'),
  search_type: queryParams.type,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
